import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS } from 'vars/index'

/** `labels` row of the content details banner: WBS badges above the title. */
export const ContentBadgesGroupSC = styled.div`
  display: flex;
  flex-wrap: var(--mcLabelsGroupWrap, wrap);
  align-items: center;
  gap: var(
    --mcContentBadgesGroupGap,
    var(--mcLabelsGroupGap, var(${FIXED_INDENTS.INDENT_40}))
  );
  letter-spacing: var(--mcLabelsGroupLetterSpacing, normal);
`

/**
 * The access-state line the concept puts between the title and the label group
 * — the PIN-lock hint or the geoblock message.
 */
export const TitleSubtitleSC = styled.div`
  ${TextBoxSC} {
    letter-spacing: var(--mcLabelsGroupLetterSpacing, normal);
  }
`
